<template>
  <inventoryCategoriesList/>
</template>
<script>
import inventoryCategoriesList from '@/components/modules/restaurant/products/subcategories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/subcategories/list.vue